module.exports = __webpack_public_path__ + "img/no_msg.b1ad702e.svg";